import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEuDdpApi } from './types';

export const euDdp: TEuDdpApi = {
	getEuDdpOrders: (payload) =>
		http.post(endpoint.euDdp.GET_ORDERS, payload).then((response) => response.data),
	getEuDdpOrder: (payload) =>
		http.post(endpoint.euDdp.GET_ORDER(payload.orderId), payload).then((response) => response.data),
	getEuDdpOrderStatuses: () =>
		http.get(endpoint.euDdp.GET_ORDER_STATUSES).then((response) => response.data),
	requestEuDdpShipment: (payload) =>
		http.post(endpoint.euDdp.REQUEST_SHIPMENT(payload.orderId)).then((response) => response.data),
	confirmEuDdpShipment: (payload) =>
		http.post(endpoint.euDdp.CONFIRM_SHIPMENT(payload.orderId), {
			expectedTotalAmount: payload.expectedTotalAmount ?? null,
			expectedBankFee: payload.expectedBankFee ?? null,
		}),
	updateEuDdpWeight: (payload) =>
		http.put(endpoint.euDdp.UPDATE_WEIGHT(payload.orderId), {
			productId: payload.productId,
			weightInKg: payload.weightInKg,
		}),
	updateEuDdpDescription: (payload) =>
		http.put(endpoint.euDdp.UPDATE_DESCRIPTION(payload.orderId), {
			productId: payload.productId,
			customsDescriptions: payload.customsDescriptions,
		}),
	updateEuDdpHs6Code: (payload) =>
		http.put(endpoint.euDdp.UPDATE_HS6_CODE(payload.orderId), {
			productId: payload.productId,
			hS6Code: payload.hS6Code,
		}),
	updateEuDdpOrderFieldValue: (payload) =>
		http.put(endpoint.euDdp.UPDATE_ORDER_FIELD_VALUE(payload.orderId), {
			fieldValues: payload.fieldValues,
		}),
	downloadEuDdpProformaInvoice: (payload) =>
		http
			.post(endpoint.euDdp.PROFORMA_INVOICE(payload.orderId), null, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	uploadEuDdpProformaInvoice: (payload) =>
		http
			.post(endpoint.euDdp.UPLOAD_PROFORMA_INOICE(payload.orderId), payload.file)
			.then((response) => response.data),
	getEuDdpSignedProformaInvoice: (payload) =>
		http
			.get(endpoint.euDdp.SIGNED_PROFORMA_INVOICE(payload.orderId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	downloadEuDdpLabel: (payload) =>
		http
			.post(endpoint.euDdp.LABEL(payload.orderId), null, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	getEuDdpDeliveryOperators: () =>
		http.post(endpoint.euDdp.DELIVERY_OPERATORS).then((response) => response.data),
	requestEuDdpS10: (payload) =>
		http
			.post(endpoint.euDdp.S10(payload.orderId), {
				s10Number: payload.s10Number,
				expectedTotalAmount: payload.expectedTotalAmount ?? null,
				expectedBankFee: payload.expectedBankFee ?? null,
			})
			.then((response) => response.data),
};
